import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import { Trophy } from "lucide-react";

export default function Records() {
  const { site } = useSite();
  const entries = [...(site.records || [])].sort((a, b) => (b.year ?? 0) - (a.year ?? 0));

  return (
    <div data-testid="records-page">
      <PageHeader
        eyebrow="Program History"
        title="Program Records & Achievements"
        subtitle={site.content.subtitle_records || "Championships, records, awards, and milestones from Norwalk Bears Baseball history."}
        testid="records-header"
      />

      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {entries.length === 0 ? (
            <div className="bg-white rounded-lg border border-slate-200 p-12 sm:p-16 text-center max-w-xl mx-auto" data-testid="records-empty-state">
              <div className="h-16 w-16 rounded-full bg-[#0F4C2A]/10 flex items-center justify-center mx-auto mb-5">
                <Trophy size={30} className="text-[#0F4C2A]" />
              </div>
              <h2 className="font-condensed text-2xl font-bold uppercase text-slate-900">Coming Soon</h2>
              <p className="mt-3 text-slate-600 text-sm sm:text-base">Program records and achievements will be posted here once they are compiled by the coaching staff.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="records-grid">
              {entries.map((r, i) => (
                <Reveal key={r.id} delay={(i % 3) * 0.07}>
                  <div className="card-lift bg-white rounded-lg border border-slate-200 overflow-hidden h-full hover:border-[#0F4C2A]/40" data-testid={`records-card-${r.id}`}>
                    <div className="bg-[#0F4C2A] diagonal-stripes px-6 py-4 flex items-center gap-3">
                      <Trophy size={20} className="text-[#F59E0B] shrink-0" />
                      <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#F59E0B]">{r.category}</span>
                    </div>
                    <div className="p-6">
                      <h3 className="font-condensed text-2xl font-bold uppercase tracking-tight text-slate-900">{r.title}</h3>
                      <div className="mt-2 flex items-center gap-2 flex-wrap">
                        {r.holder && (
                          <span className="text-sm font-bold text-[#D97706] uppercase tracking-wide">{r.holder}</span>
                        )}
                        {r.year && (
                          <span className="bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm">{r.year}</span>
                        )}
                      </div>
                      {r.description && <p className="mt-4 text-sm text-slate-600 leading-relaxed">{r.description}</p>}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
